const useSession = () => {
  const getSession = () => {
    return JSON.parse(sessionStorage.getItem("token"));
  };

  const setSession = (session) => {
    sessionStorage.setItem("token", JSON.stringify(session));
  };

  const removeSession = () => {
    sessionStorage.removeItem("token");
  };

  const isAuth = () => {
    return !!getSession();
  };

  return {
    get: getSession,
    set: setSession,
    remove: removeSession,
    isAuth: isAuth,
  };
};

export default useSession;
